export interface Resource {
  id: string;
  name: string;
  type: string;
  group: string;
  version: string;
  path: string;
  status: "Ready" | "Pending" | "Error" | "Terminating";
  created: string;
  labels?: Record<string, string>;
  metadata?: Record<string, unknown>;
}

export const mockResources: Resource[] = [
  {
    id: "1",
    name: "admin-viewer-binding",
    type: "Binding",
    group: "policies.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-15T10:30:00Z",
    labels: { environment: "production", team: "platform" },
  },
  {
    id: "2",
    name: "docs-support-agent",
    type: "AIAgent",
    group: "ai.resource.api.sap",
    version: "v1",
    path: "/ai-playground/ai-agents",
    status: "Ready",
    created: "2025-01-20T14:22:00Z",
    labels: { environment: "production", service: "support" },
  },
  {
    id: "3",
    name: "urm-support-agent",
    type: "AIAgent",
    group: "ai.resource.api.sap",
    version: "v1",
    path: "/ai-playground/ai-agents",
    status: "Ready",
    created: "2025-01-22T09:15:00Z",
    labels: { environment: "production", service: "urm" },
  },
  {
    id: "4",
    name: "platform-agent",
    type: "AIAgent",
    group: "ai.resource.api.sap",
    version: "v1",
    path: "/ai-playground/ai-agents",
    status: "Pending",
    created: "2025-01-25T16:40:00Z",
    labels: { environment: "staging", service: "platform" },
  },
  {
    id: "5",
    name: "support-chats",
    type: "ConfigMap",
    group: "system.resource.api.sap",
    version: "v1",
    path: "/ai-playground/ai-context",
    status: "Ready",
    created: "2025-01-10T08:00:00Z",
    labels: { environment: "production", category: "data" },
  },
  {
    id: "6",
    name: "urm-docs-tutorials",
    type: "ConfigMap",
    group: "system.resource.api.sap",
    version: "v1",
    path: "/ai-playground/urm-docs",
    status: "Ready",
    created: "2025-01-18T11:30:00Z",
    labels: { environment: "production", category: "documentation" },
  },
  {
    id: "7",
    name: "grafana-sa",
    type: "TechnicalClient",
    group: "iam.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-12T13:20:00Z",
    labels: { environment: "production", service: "observability" },
  },
  {
    id: "8",
    name: "admin",
    type: "Role",
    group: "policies.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-05T09:00:00Z",
    labels: { environment: "production", access: "admin" },
  },
  {
    id: "9",
    name: "viewer",
    type: "Role",
    group: "policies.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-05T09:05:00Z",
    labels: { environment: "production", access: "readonly" },
  },
  {
    id: "10",
    name: "demo-tenant-1",
    type: "Tenant",
    group: "iam.resource.api.sap",
    version: "v1",
    path: "/ai-playground/account-tenant-group-shared-tenants-c1288",
    status: "Ready",
    created: "2025-01-08T10:15:00Z",
    labels: { environment: "production", tenant: "demo" },
  },
  {
    id: "11",
    name: "jenkins",
    type: "Secret",
    group: "system.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-14T15:45:00Z",
    labels: { environment: "production", service: "ci-cd" },
  },
  {
    id: "12",
    name: "urm-mcp",
    type: "MCPService",
    group: "mcp.resource.api.sap",
    version: "v1",
    path: "/ai-playground",
    status: "Ready",
    created: "2025-01-20T12:00:00Z",
    labels: { environment: "production", service: "mcp" },
  },
];

export const resourceTypes = [
  "Binding",
  "AIAgent",
  "ConfigMap",
  "TechnicalClient",
  "Role",
  "Tenant",
  "Secret",
  "MCPService",
  "Node",
  "SystemRole",
  "SubjectGroup",
  "Tool",
  "Lease",
];

export const resourceGroups = [
  "policies.resource.api.sap",
  "ai.resource.api.sap",
  "system.resource.api.sap",
  "iam.resource.api.sap",
  "mcp.resource.api.sap",
];

export interface Event {
  id: string;
  resourceName: string;
  severity: "Info" | "Warning" | "Error";
  message: string;
  timestamp: string;
}

export const mockEvents: Event[] = [
  {
    id: "e1",
    resourceName: "docs-support-agent",
    severity: "Info",
    message: "AIAgent successfully started",
    timestamp: "2025-01-20T14:25:00Z",
  },
  {
    id: "e2",
    resourceName: "platform-agent",
    severity: "Warning",
    message: "Waiting for dependencies to be ready",
    timestamp: "2025-01-25T16:42:00Z",
  },
  {
    id: "e3",
    resourceName: "urm-support-agent",
    severity: "Info",
    message: "Configuration updated successfully",
    timestamp: "2025-01-22T09:20:00Z",
  },
  {
    id: "e4",
    resourceName: "admin-viewer-binding",
    severity: "Info",
    message: "Policy binding applied",
    timestamp: "2025-01-15T10:32:00Z",
  },
];

// Chart data for dashboard visualizations
export const resourceTrendData = [
  { date: "Jan 5", total: 5, ready: 5, pending: 0, error: 0 },
  { date: "Jan 10", total: 7, ready: 7, pending: 0, error: 0 },
  { date: "Jan 15", total: 9, ready: 8, pending: 1, error: 0 },
  { date: "Jan 20", total: 11, ready: 10, pending: 1, error: 0 },
  { date: "Jan 25", total: 12, ready: 10, pending: 2, error: 0 },
];

export const resourceTypeDistribution = [
  { name: "AIAgent", value: 4, fill: "#f59e0b" },      // Amber/Orange
  { name: "ConfigMap", value: 2, fill: "#3b82f6" },    // Blue
  { name: "Role", value: 2, fill: "#10b981" },         // Green
  { name: "Secret", value: 1, fill: "#ef4444" },       // Red
  { name: "Other", value: 3, fill: "#8b5cf6" },        // Purple
];

export const eventsByDay = [
  { date: "Jan 15", info: 2, warning: 0, error: 0 },
  { date: "Jan 18", info: 1, warning: 0, error: 0 },
  { date: "Jan 20", info: 3, warning: 1, error: 0 },
  { date: "Jan 22", info: 2, warning: 0, error: 0 },
  { date: "Jan 25", info: 1, warning: 2, error: 0 },
];
